import * as React from "react";

import {
  GridColumnMenuContainer,
  GridColumnMenuFilterItem,
  GridColumnMenuSortItem
} from "@mui/x-data-grid";
import { makeStyles } from "@mui/styles";


const useStyles = makeStyles(
  {
    root: {
      '&.MuiDataGrid-menuList': {
        minWidth: 'auto',
        padding: '4px 0'
      },
      '& .MuiListItem-root': {
        fontSize: '0.8rem',
        padding: '5px 20px 5px 10px',
        minHeight: 'auto'
      },
      '& .MuiMenuItem-root': {
        fontSize: '0.8rem',
        padding: '5px 20px 5px 10px',
        minHeight: 'auto'
      }
    }
  },
  { name: "MuiGridColumMenuContainer" }
);

const Menu = React.forwardRef(function GridColumnMenu(
  props,
  ref
) {
  const classes = useStyles();

  const { hideFilterMenu, currentColumn, ...otherProps } = props;
  return (
    <GridColumnMenuContainer className={classes.root} ref={ref} hideMenu={props.hideMenu} {...otherProps}>
      <GridColumnMenuSortItem onClick={hideFilterMenu} colDef={currentColumn} />
      <GridColumnMenuFilterItem onClick={hideFilterMenu} colDef={currentColumn} />
    </GridColumnMenuContainer>
  );
});
export default Menu;
